import styled from "styled-components";

export const ProjectMaterialsStyled = styled.div`
  padding-top: 24px;
  .fields {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr 1fr 1fr;
    gap: 16px;
    padding-bottom: 16px;
    .MuiInputBase-root {
      padding-right: 0 !important;
      background-color: #efedfd;
    }
    .po-field .MuiInputBase-root {
      background-color: #ffffff !important;
    }
    input {
      padding: 0 12px !important;
    }
  }
`;
